import React from 'react'
import cn from 'classnames'
import { CSS } from '@dnd-kit/utilities'
import { useSortable } from '@dnd-kit/sortable'
import styles from './SortableItem.module.scss'

export const TableSortableItem = (props: any) => {
  const {
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id: props['data-row-key'] })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <tr ref={setNodeRef} {...props} style={style} className={cn(props.className, isDragging && styles.dragging)}>
      {props.children}
    </tr>
  )
}
